@if(!isHidden) {
<div
  class="status-banner"
  [class.banner-basic]="variant === 'basic'"
  [class.banner-standard]="variant === 'standard'"
  [class.banner-action]="variant === 'action'"
  [class.banner-detailed]="variant === 'detailed'"
  [class.banner-code]="variant === 'code'"
  [class.banner-info]="type === 'info'"
  [class.banner-success]="type === 'success'"
  [class.banner-warning]="type === 'warning'"
  [class.banner-error]="type === 'error'"
  [class.banner-testing]="type === 'testing'"
>
  @if(dismissible) {
    <button type="button" class="banner-dismiss" (click)="dismiss()" title="Dismiss" aria-label="Dismiss">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  }
  <!-- Basic Variant: Title only with optional spinner -->
  @if(variant === 'basic') {
  <div class="banner-content">
    <div *ngIf="showSpinner" class="banner-spinner">
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <span>{{ message }}</span>
  </div>
  }

  <!-- Standard Variant: Icon + Message -->
  @if(variant === 'standard') {
  <div class="banner-content">
    <div class="banner-message">
      <i
        class="banner-icon fas"
        [class.fa-info-circle]="type === 'info'"
        [class.fa-check-circle]="type === 'success'"
        [class.fa-exclamation-triangle]="type === 'warning'"
        [class.fa-exclamation-circle]="type === 'error'"
        [class.fa-spinner]="type === 'testing' && showSpinner"
        [class.fa-spin]="type === 'testing' && showSpinner"
      ></i>
      <span>{{ message }}</span>
    </div>
  </div>
  }

  <!-- Action Variant: Icon + Message + Actions -->
  @if(variant === 'action') {
  <div class="banner-content">
    <div class="banner-message">
      <i
        class="banner-icon fas"
        [class.fa-info-circle]="type === 'info'"
        [class.fa-check-circle]="type === 'success'"
        [class.fa-exclamation-triangle]="type === 'warning'"
        [class.fa-exclamation-circle]="type === 'error'"
        [class.fa-spinner]="type === 'testing' && showSpinner"
        [class.fa-spin]="type === 'testing' && showSpinner"
      ></i>
      <span>{{ message }}</span>
    </div>
    <div class="banner-actions">
      <ng-content></ng-content>
    </div>
  </div>
  }

  <!-- Detailed Variant: Icon + Title (bold) + Body (normal) + Optional Actions -->
  @if(variant === 'detailed') {
  <div class="banner-content-vertical">
    <div class="banner-header-with-actions">
      <div class="banner-header">
        <i
          class="banner-icon fas"
          [class.fa-info-circle]="type === 'info'"
          [class.fa-check-circle]="type === 'success'"
          [class.fa-exclamation-triangle]="type === 'warning'"
          [class.fa-exclamation-circle]="type === 'error'"
          [class.fa-spinner]="type === 'testing' && showSpinner"
        ></i>
        <strong class="banner-title">{{ title }}</strong>
      </div>
      @if(hasActions) {
      <div class="banner-actions">
        <ng-content select="[bannerAction]"></ng-content>
      </div>
      }
    </div>
    <div class="banner-body">
      <ng-content></ng-content>
      @if(body) {
      <p class="mb-0" [innerHTML]="body"></p>
      } @if(linkUrl && linkText) {
      <a
        [href]="linkUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="banner-link"
        (click)="linkClick.emit($event)"
      >
        <i class="fas fa-external-link-alt"></i>
        {{ linkText }}
      </a>
      }
    </div>
  </div>
  }

  <!-- Code Variant: Optional Icon + Optional Title + Body + Code Block with Copy Button -->
  @if(variant === 'code') {
  <div class="banner-content-vertical">
    @if(showIcon || title) {
    <div class="banner-header">
      @if(showIcon) {
      <i
        class="banner-icon fas"
        [class.fa-info-circle]="type === 'info'"
        [class.fa-check-circle]="type === 'success'"
        [class.fa-exclamation-triangle]="type === 'warning'"
        [class.fa-exclamation-circle]="type === 'error'"
        [class.fa-code]="!type || type === 'info'"
      ></i>
      } @if(title) {
      <strong class="banner-title">{{ title }}</strong>
      }
    </div>
    } @if(body) {
    <div class="banner-body">
      <ng-content></ng-content>
      <p class="mb-0" [innerHTML]="body"></p>
    </div>
    }
    <div class="code-block-container">
      <pre class="code-block"><code>{{ code }}</code></pre>
      <button
        type="button"
        class="copy-button"
        (click)="copyCode()"
        [class.copied]="copySuccess"
        title="Copy to clipboard"
      >
        @if(copySuccess) {
        <i class="fas fa-check"></i>
        <span>Copied!</span>
        } @else {
        <i class="fas fa-copy"></i>
        <span>Copy</span>
        }
      </button>
    </div>
  </div>
  }
</div>
}
